<div class="app-button" [ngClass]="{}">
  <button
    class="app-button__button"
    mat-button
    [disabled]="disabled"
    [ngClass]="{
      'mat-mdc-button': type === 'basic',
      'mdc-button--unelevated mat-mdc-unelevated-button': type === 'flat' || type === 'basicRed',
      'basic-red': type === 'basicRed',
      'mdc-button--outlined mat-mdc-outlined-button': type === 'stroked',
      'withicon-stroked': type === 'iconStroked',
      'withicon-stroked-red': type === 'iconStrokedRed',
      'mdc-button-link': type === 'link',
      'custom-color-ERROR': color === 'ERROR',
      'full-width': size === 'fullWidth',
      'width-60-prc': size === 'width60prc',
      'full-height': size === 'fullHeight',
      'in-filter-row': size === 'inFilterRow',
      'in-operation-row': size === 'inOperationRow',
      extraSmall: size === 'extraSmall'
    }"
    (click)="click()"
    [type]="htmlType"
    [style.color]="labelColor"
  >
    @if (icon) {
      <mat-icon [style.color]="iconColor" [svgIcon]="icon"></mat-icon>
    }

    {{ label }}
  </button>
</div>
